/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativityControllerGetCatalogs200ResponseDataCompaniesInner } from './normativityControllerGetCatalogs200ResponseDataCompaniesInner';
import { NormativityControllerGetCatalogs200ResponseDataOwnersInner } from './normativityControllerGetCatalogs200ResponseDataOwnersInner';


export interface PersonalRequisitionReportControllerGetCatalogs200ResponseData { 
    companies?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    /**
     * Compañías para el formulario de requisición (incluye hermanas)
     */
    requisitionCompanies?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    /**
     * Unidades de negocio de las compañías del formulario
     */
    requisitionBusinessUnits?: Array<NormativityControllerGetCatalogs200ResponseDataOwnersInner>;
    jobPositions?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    requisitionTypes?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    requisitionStatus?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    vacancyStatus?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
    users?: Array<NormativityControllerGetCatalogs200ResponseDataCompaniesInner>;
}

